/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DocumentSigned/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Empty from 'DesignSystem/TysiaCopyToLocationsDialog/Empty/index'
import Error from 'DesignSystem/VideoCapture/Error/index'
import Loading from 'DesignSystem/VideoCapture/Loading/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DocumentSigned({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/DocumentSigned"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || ''
  return (<React.Fragment
>
<fromFlow.When is={[].includes(flowValue)}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={[].includes(flowValue)}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={[].includes(flowValue)}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={[].includes(flowValue)}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}